import axios from 'axios';
import { $authHost } from '.';

export type GetAppointmentsResponse = {
  result: boolean;
  data: Array<{
    club_id: string;
    appointment_id: string;
    type: string;
    status: string;
    reason_appointment: any;
    arrival_status: string;
    reason_client: any;
    payment: {
      ticket_id: string;
      type: string;
      title: string;
    };
    service: {
      title: string;
      id: string;
      description: string;
      color: any;
      course: {
        id: any;
        title: any;
      };
    };
    group: {
      id: string;
      title: string;
    };
    room: {
      id: string;
      title: string;
      description: any;
      photo: any;
      capacity: any;
      area: number;
      pictures: Array<any>;
    };
    employee: {
      id: string;
      name: string;
      position: {
        id: string;
        title: string;
      };
    };
    capacity: number;
    start_date: string;
    end_date: string;
    duration: number;
    commercial: boolean;
    pre_entry: boolean;
    marketing_badges: Array<any>;
    hide_cancel_button: boolean;
    course_activity: boolean;
  }>;
  pagination_response: {
    requested_offset: number;
    page_size: number;
    total_results: number;
  };
};

export async function getAppointments(usertoken: string) {
  return $authHost.request<GetAppointmentsResponse>({
    url: '/appointments',
    params: {
      statuses: '"planned"',
      type: 'personal',
    },
    headers: {
      'Content-Type': 'application/json',
      apikey: import.meta.env.VITE_API_KEY,
      usertoken: usertoken,
    },
  });
}

export async function deleteClasses(usertoken: string, appointment_id: string) {
  try {
    const response = await axios.delete(`${import.meta.env.VITE_API_URL}/appointment`, {
      params: {
        appointment_id: appointment_id,
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
        usertoken: usertoken,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export async function getAppointmentInfo(club_id: string, appointment_id: string) {
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/appointment`, {
      params: {
        club_id: club_id,
        appointment_id: appointment_id,
      },
      headers: {
        'Content-Type': 'application/json',
        apikey: import.meta.env.VITE_API_KEY,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}
